import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Radio, Spin, Tooltip } from 'antd';
import { path, isNil } from 'ramda';

import withFieldWrapper from 'components/hocs/withFieldWrapper';
import { Message } from 'components/common/form/ErrorHTML';
import withLoad from '../../hocs/withLoad';
import CustomIcon from 'components/common/CustomIcon';

const RadioError = ({ error, refresh }) => (
    <Tooltip title={error ? <Message error={error} /> : ''}>
        <div className="radio-error-icon text-center" onClick={() => refresh()}>
            <CustomIcon type="info-warning" />
        </div>
    </Tooltip>
);

const RadioSpinner = () => (
    <Radio.Button value={''}>
        <Spin size='small'/>
    </Radio.Button>
);

const getValue = (value) => isNil(value) ? '' : value;

export class RadioButtons extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        input: PropTypes.object,
        options: PropTypes.array,
        namePath: PropTypes.string,
        radioTranslate: PropTypes.string,
        className: PropTypes.string,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        options: [],
        namePath: 'name'
    };

    onChange = e => {
        const { onChange } = this.props;
        const { value } = e.target;

        onChange(value);
    }

    onClick = value => {
        const { value : current } = this.props.input;

        if (current === value) {
            this.props.onChange('');
        }
    }

    renderOptions() {
        const { options, namePath, radioTranslate, disabled } = this.props;

        return options.map(({ id, [namePath] : name }) => (
            <Radio.Button value={id} key={id} onClick={disabled ? undefined : () => this.onClick(id)}>
                { radioTranslate ? <Translate content={`${radioTranslate}.${name}`} /> : name }
            </Radio.Button>
        ));
    }

    getField() {
        return this.props.input;
    }

    render() {
        const { name, value } = this.getField();
        const { className, disabled } = this.props;
        const pending = path(['dictionaryAction', 'meta', 'pending'], this.props);
        const error = path(['dictionaryAction', 'meta', 'error'], this.props);
        const refresh = path(['dictionaryAction', 'refresh'], this.props);

        return (
            <div>
                <Radio.Group
                    className={className}
                    value={getValue(value)}
                    name={name}
                    onChange={this.onChange}
                    disabled={disabled}
                >
                    { this.renderOptions() }
                    { pending && <RadioSpinner /> }
                </Radio.Group>
                { error && <RadioError error={error} refresh={refresh} /> }
            </div>
        );
    }
}

export const RadioButtonsLoad = withFieldWrapper(withLoad(RadioButtons));

export default withFieldWrapper(RadioButtons);
